module.exports = __webpack_public_path__ + "media/icons/widget-icon-39d0fa60.png";